import React from 'react'
import BackendService from '../../../services/BackendService'

/**
 * Representa el componente CustomerCareUser
 *
 * @class CustomerCareUser
 * @extends {React.Component}
 */
class CustomerCareHelpDesk extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: undefined,
      supportCode: '',
      securityKey: '',
      error: false,
      loading: false
    };

    this.getData = this.getData.bind(this);
    this.onSupportCodeChange = this.onSupportCodeChange.bind(this);
    this.onSecurityCodeChange = this.onSecurityCodeChange.bind(this);
    this.resetForm = this.resetForm.bind(this);
  }

  resetForm = () => {
    this.setState({
      data: undefined,
      supportCode: '',
      securityKey: '',
      error: false,
      loading: false
    });
  }

  getData = async () => {
    const {
      supportCode,
      securityKey
    } = this.state

    this.setState({
      error: false,
      loading: true
    });

    let apiCall;

    if (supportCode.indexOf('@') !== -1) {
      apiCall = BackendService.getSupportDataFromEmail(this.props.match.params.cp, supportCode, securityKey);
    } else {
      apiCall = BackendService.getSupportData(this.props.match.params.cp, supportCode, securityKey);
    }

    apiCall
      .then(response => {
        if (!response.result.ok) {
          this.setState({
            error: true,
            loading: false
          });
        } else {
          this.setState({
            data: response.result.data,
            loading: false
          });
        }
      })
      .catch(error => {
        console.log(error);

        this.setState({
          error: true,
          loading: false
        });
      })
  }

  onSupportCodeChange = e => {
    this.setState({
      supportCode: e.target.value
    });
  }

  onSecurityCodeChange = e => {
    this.setState({
      securityKey: e.target.value
    });
  }

  formatUserInfo(userInfo) {
    return (
      <li>
        <p>Name: {userInfo.data.name} {userInfo.data.lastname}</p>
        <p>User Name: {userInfo.username}</p>
        <p>Subscriber Id: {userInfo.subscriber_id}</p>
        <p>Country Code: {userInfo.country_code}</p>
        <p>URNs:</p>
        <ul className="text-left">
          {userInfo.urn ? userInfo.urn.map(urn =>
            <li>{urn}</li>
          ): 'none'}
        </ul>
      </li>
    );
  }

  render() {
    const {
      data,
      supportCode,
      securityKey,
      loading,
      error
    } = this.state;

    let userInfo = data && data.userInfo ? (<ul className="text-left">{data.userInfo.map(this.formatUserInfo, this)}</ul>) : '';

    let deviceData = data && data.device ? (
      <div className="row">
        <ul className="text-left">
          <li>Country: {data.device.country}</li>
          <li>Browser: {data.device.browser}</li>
          <li>OS: {data.device.os}</li>
          <li>IP: {data.device.ip}</li>
          <li>Country (user IP): {data.device.ipCountry}</li>
        </ul>
      </div>
    ):(<div className="row"> - </div>);

    let cloudPassData = data && data.cloudPass ? (<div className="row">
      <ul className="text-left">
        <li>Autenticated: {data.cloudPass.toolboxUserToken ? 'Yes' : 'No'}</li>
        <li>MSO: {data.cloudPass.mso}</li>
        <li>MSO Short: {data.cloudPass.msoShort}</li>
        <li>Country: {data.cloudPass.country}</li>
        <li>Customer Id: {data.cloudPass.customer}</li>
        <li>Subscriber Id: {data.cloudPass.subscriberId}</li>
        <li>Toolbox User Token: {data.cloudPass.toolboxUserToken}</li>
      </ul>
    </div>
    ):(<div className="row"> - </div>);

    let hasAccessToError = data && data.hasAccessToError ? (
      <React.Fragment>
        <div className="row">
          <label className="text-underline text-bold">Test URNs Error:</label>
        </div>
        <div className="row">
          <ul className="text-left">
            <li>Status: {data.hasAccessToError.status}</li>
            <li>Code: {data.hasAccessToError.errorCode}</li>
            <li>Message: {data.hasAccessToError.message}</li>
          </ul>
        </div>
      </React.Fragment>) : ('');

    return (
      <div className="container">
        <div className="row margin-bottom-3">
          <h2 className="center-tag">Support</h2>
        </div>

        {error ?
          <div className="alert alert-danger margin-bottom-3" role="alert">
            An error occurred
          </div>
          : ''}
        {!data ?
          <React.Fragment>
            {loading ?
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              :
              <form autoComplete="off" onSubmit={this.getData} className="center-tag margin-bottom-3" noValidate>

              <div className="row">
                    <div className="form-group row">
                      <label htmlFor="inputSupportCode" className="col-sm-5 col-form-label">Support Code or User
                        Email</label>
                      <div className="col-sm-7">
                        <input value={supportCode} onChange={this.onSupportCodeChange} type="text"
                               className="form-control" id="inputSupportCode" placeholder=""></input>
                      </div>
                    </div>

                    <div className="form-group row">
                      <label htmlFor="inputSecurityKey" className="col-sm-5 col-form-label">Security Key</label>
                      <div className="col-sm-7">
                        <input value={securityKey} onChange={this.onSecurityCodeChange} type="password"
                               className="form-control" id="inputSecurityKey" placeholder=""></input>
                      </div>
                    </div>

                </div>

                <div className="row">
                  <button className="btn btn-outline-primary center-tag" type="submit" onClick={this.getData}>
                    Search
                  </button>
                </div>
              </form>
            }
          </React.Fragment>
          :
          <div>
            {userInfo ?
              <React.Fragment>
                <div className="row">
                  <label className="text-underline text-bold">User Info:</label>
                </div>
                <div className="row">
                  {userInfo}
                </div>
              </React.Fragment>
              :
              <React.Fragment>
                <div className="row">
                  <label>Support Code: <strong>{data._id}</strong></label>
                </div>

                <div className="row">
                  <label className="text-underline text-bold">Device:</label>
                </div>
                {deviceData}

                <div className="row">
                  <label className="text-underline text-bold">Cloud Pass:</label>
                </div>
                {cloudPassData}

                { data.hasAccessTo && data.hasAccessTo.length > 0 ?
                <React.Fragment>
                  <div className="row">
                    <label className="text-underline text-bold">Test URNs:</label>
                  </div>
                  <div className="row">
                    <ul className="text-left">
                      {data.hasAccessTo ? data.hasAccessTo.map(access =>
                        <li>{access.urn}: {access.access.toString()}</li>
                      ): 'none'}
                    </ul>
                  </div>
                </React.Fragment> : ''}

                {hasAccessToError}
              </React.Fragment>
            }

            <div className="row">
              <button className="btn btn-outline-primary center-tag margin-bottom-3" type="button" onClick={this.resetForm}>
                Reset
              </button>
            </div>

          </div>
        }
      </div>
    );
  }
}

export default CustomerCareHelpDesk
